export default __webpack_public_path__ + "static/media/HostaAI_LogoWithTagline.a22e3799.png";